"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radius = {
  button: 4,
  popper: 2,
  modal: 4,
  input: 2,
  paper: 4,
  tag: 12
};